import { render, staticRenderFns } from "./SearchResultTabsVenues.vue?vue&type=template&id=0052a71f&"
import script from "./SearchResultTabsVenues.vue?vue&type=script&lang=js&"
export * from "./SearchResultTabsVenues.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports